import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { mergeEntities } from '@utils/object.js'

export const initialState = {}

export const comment = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_TIMELINE_COMMENTS, (state, action) => receiveComments(state, action))
})

function receiveComments(state, action) {
  const { payload: comments } = action
  return mergeEntities(state, comments)
}

export default comment
